module.exports = __webpack_public_path__ + "static/media/1.0e91b791.jpg";